import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 8rem);
  display: flex;
  flex-direction: column;

  header {
    width: 100%;
    padding: 1rem 0;
    display: flex;

    button {
      margin-right: 1rem;
    }
  }
`;

export const Mapa = styled.div`
  flex: 1;
`;

export const Menu = styled.div`
  padding: 1rem;
  width: 35rem;
  height: 60rem;
  display: flex;
  flex-direction: column;

  form {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;

    > div {
      margin-top: 1rem;
    }

    .form-group {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 1rem;
    }

    p.MuiFormHelperText-root.Mui-error {
      margin-top: 0;
    }
  }
`;

export const Footer = styled.div`
  margin-top: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.div`
  width: 100%;
  height: 0;
  flex: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .item {
    display: grid;
    grid-template-columns: 3rem calc(100% - 17.5rem) 1fr;

    cursor: pointer;
    font-size: 1.2rem;

    span {
      color: #22474f;
      flex: 1;

      :last-child {
        min-width: 15rem;
      }
    }

    span + span {
      border-left: 1px solid rgba(0, 0, 0, 0.2);
      padding: 0 1rem;
      white-space: nowrap;
    }
  }

  & :hover {
    background: #22474f;

    span {
      color: #fff;
    }
  }
`;

export const Empty = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  color: #999;
  font-weight: 700;
  font-size: 2rem;

  background: #fff;
  pointer-events: none;
`;
